import React from 'react';
import { Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MobileHeader = ({ onLogout }) => {
  const navigate = useNavigate();

  return (
    <header className="flex-shrink-0 bg-white/90 backdrop-blur-md border-b border-notion-border px-4 py-3 flex items-center justify-between sticky top-0 z-50">
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 bg-stone-800 rounded flex items-center justify-center text-white text-xs font-bold">
          K
        </div>
        <span className="font-semibold text-base tracking-tight text-notion-text">Kaeros</span>
      </div>

      {/* Settings entry point for mobile */}
      <button
        onClick={() => navigate('/settings')}
        className="w-10 h-10 flex items-center justify-center rounded-full text-stone-400 hover:text-stone-700 hover:bg-stone-100 active:bg-stone-200 transition-colors"
        aria-label="Settings"
      >
        <Settings className="w-5 h-5" />
      </button>
    </header>
  );
};

export default MobileHeader;
